var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoResultFound({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 114,
    viewBox: "0 0 133 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126 82.6C126 81.1641 124.836 80 123.4 80H9.67599C8.24005 80 7.07599 81.1641 7.07599 82.6C7.07599 84.0359 8.24004 85.2 9.67598 85.2H24.9198C26.3557 85.2 27.5198 86.3641 27.5198 87.8C27.5198 89.2359 26.3557 90.4 24.9198 90.4H21.8705C20.4346 90.4 19.2705 91.5641 19.2705 93C19.2705 94.4359 20.4346 95.6 21.8705 95.6H30.9198C32.3557 95.6 33.5198 96.7641 33.5198 98.2C33.5198 99.6359 32.3557 100.8 30.9198 100.8H26.8705C25.4346 100.8 24.2705 101.964 24.2705 103.4C24.2705 104.836 25.4346 106 26.8705 106H88.8043C90.2402 106 91.4043 104.836 91.4043 103.4C91.4043 101.964 90.2402 100.8 88.8043 100.8H75.1C73.6641 100.8 72.5 99.6359 72.5 98.2C72.5 96.7641 73.6641 95.6 75.1 95.6H115.303C116.739 95.6 117.903 94.4359 117.903 93C117.903 91.5641 116.739 90.4 115.303 90.4H101.852C100.416 90.4 99.2523 89.2359 99.2523 87.8C99.2523 86.3641 100.416 85.2 101.852 85.2H123.4C124.836 85.2 126 84.0359 126 82.6ZM41.8584 100.8C40.4224 100.8 39.2584 99.6359 39.2584 98.2C39.2584 96.7641 40.4224 95.6 41.8584 95.6H50.4C51.8359 95.6 53 96.7641 53 98.2C53 99.6359 51.8359 100.8 50.4 100.8H41.8584Z",
    fill: "#E4ECFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6322 103.4C94.6322 101.964 95.7963 100.8 97.2322 100.8H109.607C111.043 100.8 112.207 101.964 112.207 103.4C112.207 104.836 111.043 106 109.607 106H97.2322C95.7963 106 94.6322 104.836 94.6322 103.4Z",
    fill: "#E4ECFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4772 93C13.4772 91.5641 12.3131 90.4 10.8772 90.4H4.6C3.16406 90.4 2 91.5641 2 93C2 94.4359 3.16406 95.6 4.6 95.6H10.8772C12.3131 95.6 13.4772 94.4359 13.4772 93Z",
    fill: "#E4ECFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1232 51.8849H32.8401V85.2963H63.1232V51.8849Z",
    fill: "white",
    stroke: "#022DB7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3401 51.3849H63.6233L55.0204 42H23.7373L32.3401 51.3849Z",
    fill: "#022DB7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3401 51.3849V62.7251H21L32.3401 51.3849Z",
    fill: "#022DB7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5989 51.3849H63.6233V85.7963H99.5989V51.3849Z",
    fill: "#022DB7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4475 51.6349L107.006 65.9943H71.5949L64.0373 51.6349H99.4475Z",
    fill: "white",
    stroke: "#022DB7",
    strokeWidth: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5031 51.1349L106.768 44.5959H71.5412L64.2746 51.1349H99.5031Z",
    fill: "white",
    stroke: "#022DB7",
    strokeWidth: 0.5
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M53 58H37V62H53V58Z",
    fill: "#022DB7"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M26 28.1207L32.4807 34.224",
    stroke: "#022DB7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7958 23L40.3815 30.7486",
    stroke: "#022DB7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M102.541 28.1207L96.0598 34.224",
    stroke: "#022DB7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7448 23L88.1591 30.7486",
    stroke: "#022DB7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResultFound);
export default __webpack_public_path__ + "static/media/NoResultFound.afe74325c7d0792f641a476e3c869786.svg";
export { ForwardRef as ReactComponent };